<template>
    <div>
        <SingleFieldBarChart
                             :chart_config="chart_config"
                             :extent_id="extent_id"
                             :height="chart_height"
                             :width="chart_width"
                             :additional_filters="additional_filters"
                             :snapshotId="snapshotId"
        />
    </div>
    
</template>

<script>
    export default {
        name: "ReportCompSingle",
        props: ['chart_config','extent_id','chart_height','chart_width','additional_filters','snapshotId'],
        data() {
            return {
                some_var: null,
            }
        },
        methods: {
        },
    }
</script>
